// extracted by mini-css-extract-plugin
export default {"gameRadioGroup":"nK_nL","gameRadioGroup__option":"nK_nM","gameRadioGroup__input":"nK_nN","gameRadioGroup__label":"nK_nO","gameRadioGroup__labelContent":"nK_nP"};